namespace Ir.Components.Email.EmailLog {
    interface IViewModel {
        dataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        dataGridComponent: DevExpress.ui.dxDataGrid;
        formOptions: DevExpress.ui.dxForm.Properties;
        dateRangeOptions: DevExpress.ui.dxDateRangeBox.Properties;
        recipientsOptions: DevExpress.ui.dxTextBox.Properties;
        sentOptions: DevExpress.ui.dxCheckBox.Properties;
        startTimeOptions: DevExpress.ui.dxDateBox.Properties;
        startTimeComponent: DevExpress.ui.dxDateBox;
        endTimeOptions: DevExpress.ui.dxDateBox.Properties;
        endTimeComponent: DevExpress.ui.dxDateBox;
        applyOptions: DevExpress.ui.dxButton.Properties;

        currentLog: KnockoutObservable<any>;
        sentFilter: KnockoutObservable<boolean>;
        recipientsFilter: KnockoutObservable<string>;
        startDateFilter: KnockoutObservable<string>;
        endDateFilter: KnockoutObservable<string>;
        startTimeFilter: KnockoutObservable<string>;
        endTimeFilter: KnockoutObservable<string>;
    }
    interface IParams {
        result: EmailLogResultVM;
    }
    let popupComponent: DevExpress.ui.dxPopup;

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        this.currentLog = ko.observable(null);
        this.sentFilter = ko.observable(null);
        this.recipientsFilter = ko.observable("");
        this.startDateFilter = ko.observable(params.result.startDate);
        this.endDateFilter = ko.observable(params.result.endDate);
        this.startTimeFilter = ko.observable(params.result.startTime);
        this.endTimeFilter = ko.observable(params.result.endTime);

        this.dataGridOptions = {
            height: 270,
            width: 778,
            dataSource: params.result.logs,
            showColumnLines: false,
            showRowLines: true,
            rowAlternationEnabled: false,
            columns: [
                { dataField: "emailLogId", caption: "Id", width: 80, allowGrouping: false },
                {
                    dataField: "date",
                    width: 125,
                    customizeText(cellInfo) {
                        return formatDateTime(cellInfo.value)
                    },
                },
                { dataField: "sent", width: 50 },
                { dataField: "status" },
                {
                    type: "buttons",
                    width: 75,
                    buttons: [{
                        hint: "Copy Status",
                        icon: "copy",
                        onClick(e) {
                            irGlobal.copyTextToClipboard(e.row.data.status || "", "Status copied to clipboard");
                        }
                    }, {
                        hint: "Email",
                        icon: "email",
                        onClick(e) {
                            Ir.Components.Email.ScheduledEmailEditor.show(true, e.row.data.emailId, false);
                        }
                    }],
                    allowGrouping: false
                }
            ],
            showBorders: true,
            focusedRowKey: params.result.logs.length > 0 ? params.result.logs[0].id : null,
            focusedRowEnabled: true,
            keyExpr: "id",
            groupPanel: {
                visible: true
            },
            scrolling: {
                mode: 'virtual',
                useNative: false
            },
            paging: {
                enabled: false
            },
            onInitialized(e) {
                self.dataGridComponent = e.component;
            },
            onFocusedRowChanged(e) {
                self.currentLog(e.row?.data);
            }
        };

        this.formOptions = {
            height: 130,
            readOnly: true,
            formData: self.currentLog,
            items: [
                {
                    dataField: 'recipients',
                    editorType: 'dxTextArea',
                    editorOptions: {
                        height: 60
                    }
                },
                {
                    dataField: 'cc',
                    label: { text: 'CC' },
                    editorType: 'dxTextArea',
                    editorOptions: {
                        height: 40
                    }
                },
                {
                    dataField: 'bcc',
                    label: { text: 'BCC' },
                    editorType: 'dxTextArea',
                    editorOptions: {
                        height: 40
                    }
                },
                {
                    dataField: 'smtpResponse',
                    caption: 'STMP Response',
                    editorType: 'dxTextArea',
                }
            ]
        };

        this.dateRangeOptions = {
            multiView: false,
            displayFormat: irSettings.dateFormat,
            value: [params.result.startDate, params.result.endDate],
            labelMode: "hidden",
            onValueChanged(e) {
                let previousStartDate = e.previousValue[0];
                let previousEndDate = e.previousValue[1];
                let newStartDate = e.value[0];
                let newEndDate = e.value[1];

                if (previousStartDate !== newStartDate || previousEndDate !== newEndDate) {
                    if (typeof newStartDate === "object") {
                        self.startDateFilter(DevExpress.localization.formatDate(newStartDate, "yyyy-MM-dd"));
                    }
                    else {
                        self.startDateFilter(newStartDate);
                    }

                    if (typeof newEndDate === "object") {
                        self.endDateFilter(DevExpress.localization.formatDate(newEndDate, "yyyy-MM-dd"));
                    }
                    else {
                        self.endDateFilter(newEndDate);
                    }
                }
            }
        };

        this.recipientsOptions = {
            value: self.recipientsFilter as any,
            showClearButton: true
        };

        this.sentOptions = {
            enableThreeStateBehavior: true,
            value: self.sentFilter as any,
            text: 'Sent'
        };

        this.startTimeOptions = {
            value: params.result.startTime,
            type: 'time',
            useMaskBehavior: true,
            showDropDownButton: false,
            displayFormat: irSettings.displayTimeFormat,
            onInitialized(e) {
                self.startTimeComponent = e.component;
            },
            onValueChanged(e){
                let endTime = self.endTimeComponent.option("value");
                if (e.value > endTime) {
                    self.endTimeComponent.option("value", e.value);
                }

                self.startTimeFilter(e.value);
            }
        };
        this.endTimeOptions = {
            value: params.result.endTime,
            type: 'time',
            useMaskBehavior: true,
            showDropDownButton: false,
            displayFormat: irSettings.displayTimeFormat,
            onInitialized(e) {
                self.endTimeComponent = e.component;
            },
            onValueChanged(e) {
                let startTime = self.startTimeComponent.option("value");
                if (e.value < startTime) {
                    self.startTimeComponent.option("value", e.value);
                }

                self.endTimeFilter(e.value);
            }
        };

        this.applyOptions = {
            text: 'Apply',
            icon: 'filter',
            onClick() {
                var filterOptions = {
                    startDate: self.startDateFilter(),
                    endDate: self.endDateFilter(),
                    startTime: self.startTimeFilter(),
                    endTime: self.endTimeFilter(),
                    recipients: self.recipientsFilter(),
                    sent: self.sentFilter()
                } as EmailLogFilterOptions;

                if (filterOptions.startDate && !filterOptions.endDate || !filterOptions.startDate && filterOptions.endDate ||
                    filterOptions.startTime && !filterOptions.endTime || !filterOptions.startTime && filterOptions.endTime) {

                    DevExpress.ui.dialog.alert(`The date range and/or the time range needs to be selected, it is not allowed to select only half of the date or a time`, "Emails Management");
                    return;
                }

                let resultVM = getLogs(params.result.emailId, filterOptions)
                params.result.logs = resultVM.logs;
                self.dataGridComponent.option({
                    dataSource: params.result.logs,
                    focusedRowKey: params.result.logs.length > 0 ? params.result.logs[0].id : null
                });
            }
        };
    }

    function getLogs(emailId: number = null, filterOptions: EmailLogFilterOptions = null): EmailLogResultVM {
        let result: EmailLogResultVM;
        let o = {
            url: `${urlConfigs.email}GetEmailLogs`,
            data: emailId === null ? { filter: filterOptions } : { emailId: emailId, filter: filterOptions },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data: EmailLogResultVM, e) {
            result = data;
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get email logs";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return result;
    }

    export function show(emailId: number = null) {
        if (popupComponent) {
            let element = popupComponent.element();
            popupComponent.dispose();
            element.remove();
        }

        let result: EmailLogResultVM = getLogs();
        let popupOptions = {
            width: 800,
            height: 700,
            showTitle: true,
            title: "Email Logs",
            visible: false,
            dragEnabled: false,
            hideOnOutsideClick: false,
            showCloseButton: true,
            position: {
                at: "center",
                my: "center",
            },
            onInitialized(e) {
                popupComponent = e.component;
                popupComponent.show();
            }
        } as DevExpress.ui.dxPopover.Properties;

        let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <email-log params="result: result"></email-log>
            </div>`);
        $popover.appendTo('body');

        ko.applyBindings({ popupOptions, result }, $popover[0]);
    }
}